
import Header from '../../components/feature/Header';
import HeroSection from '../../components/feature/HeroSection';
import ModulesSection from '../../components/feature/ModulesSection';
import BenefitsSection from '../../components/feature/BenefitsSection';
import FeaturesSection from '../../components/feature/FeaturesSection';
import SuccessSection from '../../components/feature/SuccessSection';
import ContactSection from '../../components/feature/ContactSection';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <ModulesSection />
      <BenefitsSection />
      <FeaturesSection />
      <SuccessSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
